import { getInlineNotificationStyles } from './InlineNotificationStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { NotificationBaseBody } from '../NotificationBaseBody/NotificationBaseBody.js';

const InlineNotification = _ref => {
  let {
    'data-id': dataId,
    type,
    className,
    ...rest
  } = _ref;
  return jsx("article", {
    css: getInlineNotificationStyles(type),
    className: className,
    "data-id": dataId,
    children: jsx(NotificationBaseBody, {
      type: type,
      ...rest
    })
  });
};

export { InlineNotification };
//# sourceMappingURL=InlineNotification.js.map
